import React from 'react'

const Action = () => {
  return (
    <section id="call-to-action" className="call-to-action section dark-background">

    <img src="assets/img/cta-bg.jpg" alt="Call to Action Background"/>

    <div className="container">

      <div className="row" data-aos="zoom-in" data-aos-delay="100">
        <div className="col-xl-9 text-center text-xl-start">
          <h3>Ready to Take Your Business to the Next Level?</h3>
          <p>Whether you're looking for a new web application, a custom software solution, or a comprehensive digital marketing strategy, we are here to help you achieve your business goals. Let us guide you through the digital transformation process.</p>
        </div>
        <div className="col-xl-3 cta-btn-container text-center">
          <a className="cta-btn align-middle" href="#contact">Get Started Today</a>
        </div>
      </div>

    </div>

  </section>
  )
}

export default Action
